import { SendIcon } from "@ubnt/icons";
import React, { useRef, useState } from "react";
import * as S from "./UniFiGPT.styles";
import { useTranslation } from "hooks/useTranslation";
import AILogo from "./assets/ai-logo.jpg";

const HELP_GPT_URL = __CONFIG__.HELP_GPT_URL || "https://gpt.help.ui.com";

export const UniFiGPT = () => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const onExpandGpt = () => {
    setIsExpanded(true);

    if (ref.current) {
      const { top } = ref?.current?.getBoundingClientRect();
      const offset = 48;

      window.scrollTo({
        behavior: "smooth",
        top: top + window.scrollY - offset,
      });
    }
  };

  return (
    <S.Background ref={ref}>
      <S.Container $isExpanded={isExpanded}>
        <S.RelativeContainer $isVisible={isExpanded}>
          <S.TransparentButton onClick={() => setIsExpanded(false)}>
            <S.StyledCloseIcon size="original" />
          </S.TransparentButton>
          <S.StyledEmbed src={`${HELP_GPT_URL}?embed=true`} />
        </S.RelativeContainer>

        <S.InputBlockWrapper $isVisible={!isExpanded}>
          <S.LogoWrapper>
            <S.GptTitle>{t("commons.unifiGpt")}</S.GptTitle>
            <S.StyledLogoImg src={AILogo} alt="UniFi GPT Logo" />
          </S.LogoWrapper>

          <S.InputButton onClick={onExpandGpt}>
            <S.StyledInputPlaceholder>
              {t("unifiGpt.placeholderText")}
            </S.StyledInputPlaceholder>

            <S.StyledSendButton>
              <SendIcon size="original" variant="fill" color="#808893" />
            </S.StyledSendButton>
          </S.InputButton>
        </S.InputBlockWrapper>
      </S.Container>
    </S.Background>
  );
};
